import React, { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Slider, Typography } from "@mui/material";

import { formatToTime } from "../../../utils/Duration";
import {
  getPlayerState,
  setPlayedPercent,
} from "../../../redux/features/playerSlice";

const TimeLine = forwardRef((props, ref) => {
  const { playedPercent, loadedPercent } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const [hoverSlider, setHoverSlider] = useState(false);
  const showDuration =
    playedPercent < 0.9 || (!hoverSlider && playedPercent >= 0.9);

  const handleSeekMouseUp = () => {
    // ref.current?.player.seekTo(playedPercent);

    setHoverSlider(false);
  };

  const handleSeekMouseDown = (e) => {
    setHoverSlider(true);
  };
  const handleSeekChange = (e) => {
    dispatch(setPlayedPercent(parseFloat(e.target.value)));
    ref.current?.seekTo(e.target.value);
  };

  return (
    <Box>
      {showDuration && (
        <Typography
          style={{
            fontSize: 12,
            position: "absolute",
            right: 4,
            bottom: "50px",
            color: "white",
          }}
        >
          {props.data && formatToTime(props.data.duration)}
        </Typography>
      )}
      <Box
        sx={{
          height: 4,
          background: "white",
          width: `${
            (
              loadedPercent +
              (loadedPercent > 0 && loadedPercent < 0.9 ? 0.09 : 0)
            ).toFixed(3) * 100
          }%`,
          position: "absolute",
          bottom: 38,
          borderRadius: "8px",
          color: "white",
          zIndex: 1,
          pointerEvents: "none",
        }}
      ></Box>
      <Slider
        disabled={!props.data}
        valueLabelDisplay='on'
        valueLabelFormat={formatToTime(
          props.data ? props.data.duration * playedPercent : 0
        )}
        aria-label='timeline'
        min={0}
        max={1}
        step={0.001}
        value={playedPercent}
        onTouchStart={handleSeekMouseDown}
        onMouseDown={handleSeekMouseDown}
        onChange={handleSeekChange}
        onChangeCommitted={handleSeekMouseUp}
        sx={{
          position: "absolute",
          padding: "0 !IMPORTANT",
          bottom: 38,
          width: "100%",

          "& .MuiSlider-track": {
            border: "none",
            zIndex: 2,
          },
          "& .MuiSlider-thumb": {
            width: hoverSlider ? 24 : 36,
            height: hoverSlider ? 24 : 16,
            zIndex: 2,
            borderRadius: hoverSlider ? "50%" : "10px",
            backgroundColor: "#fff",
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
              boxShadow: "inherit",
            },
            "&:before": {
              display: "none",
            },
          },
          "& .MuiSlider-rail": {
            backgroundColor: "white !IMPORTANT",
            opacity: 0.5,
          },
          "& .MuiSlider-valueLabelOpen": { background: "none !IMPORTANT" },
          "& .MuiSlider-valueLabelLabel": {
            position: "absolute",
            bottom: hoverSlider ? -8 : -28,
            left: 2,
            fontSize: 11,
            color: hoverSlider ? "white" : "black !IMPORTANT",
          },
        }}
      />
    </Box>
  );
});
export default TimeLine;
